var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"core-values"},[_c('div',{staticClass:"values-content"},[_c('div',{staticClass:"top-right-box"},[_c('div',{staticClass:"tit-eh"},[_vm._v("FOCUS ON INNOVATION AND SERVICE FIRST")]),_c('div',{staticClass:"tit-zh"},[_vm._v("华跃 专注创新，服务至上")])])])])
}]

export { render, staticRenderFns }